import { SectionTitle } from "../Form/Form";
import { SmallSectionHeaderRegular } from "../Typography/Typography";
import { t } from "i18next";
import styled from "styled-components";
import { ToggleSwitchV2 } from "../ToggleSwitch/ToggleSwitch";
import { Card } from "../../layout/publicPageLayout";

export type TLeadsPreferences = {
  storefront_id: string;
  leads: boolean;
  leads_enable_quote_request: boolean;
  leads_enable_sample_request: boolean;
  leads_enable_registration: boolean;
  leads_enable_contact_us: boolean;
};

const ToggleSwitchWrapper = styled.div`
  margin: 20px 0;
`;

export function LeadsNotifications({
  leadsNotifications,
  setLeadsNotifications,
}: {
  leadsNotifications: TLeadsPreferences;
  setLeadsNotifications: any;
}) {
  const handleMainLeadsToggle = () => {
    const newValue = !leadsNotifications.leads;
    setLeadsNotifications({
      ...leadsNotifications,
      leads: newValue,
      leads_enable_quote_request: newValue,
      leads_enable_sample_request: newValue,
      leads_enable_registration: newValue,
      leads_enable_contact_us: newValue,
    });
  };

  const handleSubToggle = (field: keyof TLeadsPreferences) => {
    const updatedNotifications = {
      ...leadsNotifications,
      [field]: !leadsNotifications[field],
    };

    // Update main toggle based on sub-toggles
    updatedNotifications.leads =
      updatedNotifications.leads_enable_quote_request ||
      updatedNotifications.leads_enable_sample_request ||
      updatedNotifications.leads_enable_registration ||
      updatedNotifications.leads_enable_contact_us;

    setLeadsNotifications(updatedNotifications);
  };

  return (
    <>
      <SectionTitle style={{ margin: "30px 0 3px" }}>
        {t("Notification Preferences")}
      </SectionTitle>
      <SmallSectionHeaderRegular style={{ margin: "2px 0 0" }}>
        {t("Set preferences to receive email updates for new leads")}
      </SmallSectionHeaderRegular>

      <ToggleSwitchWrapper style={{ margin: "20px 0 15px" }}>
        <ToggleSwitchV2
          label={t("Leads")}
          name={"leads_notification"}
          checked={leadsNotifications.leads}
          onChange={handleMainLeadsToggle}
        />
      </ToggleSwitchWrapper>

      {leadsNotifications.leads && (
        <Card style={{ background: "#fff", padding: "5px 15px" }}>
          <ToggleSwitchWrapper>
            <ToggleSwitchV2
              label={t("Quote Request")}
              name={"leads_enable_quote_request"}
              checked={leadsNotifications.leads_enable_quote_request}
              onChange={() => handleSubToggle("leads_enable_quote_request")}
            />
          </ToggleSwitchWrapper>
          <ToggleSwitchWrapper>
            <ToggleSwitchV2
              label={t("Sample Request")}
              name={"leads_enable_sample_request"}
              checked={leadsNotifications.leads_enable_sample_request}
              onChange={() => handleSubToggle("leads_enable_sample_request")}
            />
          </ToggleSwitchWrapper>
          <ToggleSwitchWrapper>
            <ToggleSwitchV2
              label={t("Register")}
              name={"leads_enable_registration"}
              checked={leadsNotifications.leads_enable_registration}
              onChange={() => handleSubToggle("leads_enable_registration")}
            />
          </ToggleSwitchWrapper>
          <ToggleSwitchWrapper>
            <ToggleSwitchV2
              label={t("Contact Us")}
              name={"leads_enable_contact_us"}
              checked={leadsNotifications.leads_enable_contact_us}
              onChange={() => handleSubToggle("leads_enable_contact_us")}
            />
          </ToggleSwitchWrapper>
        </Card>
      )}
    </>
  );
}
